require('./_wks-define')('asyncIterator');



/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/es7.symbol.async-iterator.js
 **/